module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "20",
      "height": "18",
      "viewBox": "0 0 10 10",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.42271 0.104911L8.8245 2.5067C8.89146 2.57366 8.92941 2.66518 8.92941 2.76004V4.56591C8.68647 4.35902 8.41612 4.18627 8.12584 4.05268V3.68304H5.71512C5.5908 3.68304 5.47157 3.63365 5.38367 3.54574C5.29576 3.45783 5.24637 3.33861 5.24637 3.21429V0.803571H1.87584V9.19643H3.79028C3.9106 9.37176 4.04751 9.5369 4.19999 9.68938C4.31208 9.80147 4.43101 9.90515 4.5558 10H1.42941C1.23186 10 1.07227 9.8404 1.07227 9.64286V0.357143C1.07227 0.159598 1.23186 0 1.42941 0H6.17048C6.26535 0 6.35575 0.0379464 6.42271 0.104911ZM6.0053 2.92411H8.10575L6.0053 0.823661V2.92411Z",
      "fill": "#83BBAC"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.66645 9.99989C7.03123 9.99989 7.39244 9.92804 7.72946 9.78844C8.06647 9.64885 8.37269 9.44424 8.63064 9.1863C8.88858 8.92836 9.09319 8.62214 9.23278 8.28512C9.37238 7.94811 9.44423 7.5869 9.44423 7.22211C9.44423 6.85733 9.37238 6.49612 9.23278 6.1591C9.09319 5.82209 8.88858 5.51587 8.63064 5.25793C8.37269 4.99999 8.06647 4.79538 7.72946 4.65578C7.39244 4.51619 7.03123 4.44434 6.66645 4.44434C5.92974 4.44434 5.2232 4.73699 4.70226 5.25793C4.18133 5.77886 3.88867 6.4854 3.88867 7.22211C3.88867 7.95883 4.18133 8.66536 4.70226 9.1863C5.2232 9.70723 5.92974 9.99989 6.66645 9.99989ZM6.59484 8.34557L8.13805 6.49372L7.66398 6.09866L6.33682 7.69094L5.65009 7.0039L5.21367 7.44032L6.1396 8.36625L6.37849 8.60514L6.59484 8.34557Z",
      "fill": "#83BBAC"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7708569e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/VerifyDocumentIcon.vue
// module id = 1504
// module chunks = 159